import React from 'react';
import { Settings as SettingsIcon, Sun, Moon, Check } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const THEME_OPTIONS = [
  {
    id: 'light',
    label: 'Açık tema',
    description: 'Beyaz zemin, yumuşak gri tonlar — aydınlık ortamlar için.',
    icon: Sun,
    swatch: ['#ffffff', '#f1f4f9', '#2d6459'],
  },
  {
    id: 'dark',
    label: 'Koyu tema',
    description: 'Lacivertimsi siyah zemin — düşük ışıkta göz yormaz.',
    icon: Moon,
    swatch: ['#111318', '#1a1d27', '#4a9e8a'],
  },
];

const Settings = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="mx-auto max-w-4xl p-6">
      <div className="mb-8">
        <h1 className="flex items-center gap-2 text-3xl font-bold text-white">
          <SettingsIcon className="h-8 w-8 text-accent-300" />
          Uygulama Ayarları
        </h1>
      </div>

      <section className="card">
        <h2 className="mb-1 flex items-center gap-2 text-lg font-semibold text-white">
          <Sun className="h-5 w-5 text-accent-300" /> Görünüm
        </h2>
        <p className="mb-4 text-sm text-slate-400">
          Panelin renk temasını seçin. Tercihiniz bu cihazda kaydedilir.
        </p>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {THEME_OPTIONS.map((opt) => {
            const Icon = opt.icon;
            const active = theme === opt.id;
            return (
              <button
                key={opt.id}
                type="button"
                onClick={() => setTheme(opt.id)}
                aria-pressed={active}
                className={`flex items-start gap-3 rounded-xl border p-4 text-left transition-colors ${
                  active
                    ? 'border-accent-400/60 bg-accent-400/10'
                    : 'border-white/10 hover:border-white/20 hover:bg-white/[0.04]'
                }`}
              >
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/[0.06] text-accent-300">
                  <Icon className="h-5 w-5" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <span className="font-semibold text-white">{opt.label}</span>
                    {active && <Check className="h-4 w-4 text-accent-300" />}
                  </span>
                  <span className="mt-0.5 block text-xs text-slate-400">{opt.description}</span>
                  <span className="mt-2 flex gap-1.5">
                    {opt.swatch.map((c) => (
                      <span
                        key={c}
                        className="h-4 w-6 rounded-md ring-1 ring-black/10"
                        style={{ background: c }}
                      />
                    ))}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Settings;
